import { GET_SUBSCRIBERS } from '../../actions/types/SubscribersTypes';
import { LOADING_FILES } from '../../actions/types/files/FilesTypes';

const initialState = {
  subscribers: [],
  loading: false,
};

const SubscribersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIBERS:
      return {
        ...state,
        subscribers: action.payload,
        loading: false,
      };

    case LOADING_FILES:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};

export default SubscribersReducer;
